'use client'

import { SetStateAction,useState } from 'react'
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

import Banner02 from '@/components/banner-02'
import Input from '@/components/ui/Input'
import { redirectToTheBestHome } from '@/actions/redirect-to-the-best-home';
import { Button } from '@/components/ui/button';


export default function ForgotPasswordForm() {

    const session = useSession()
    
    const [email, setEmail] = useState("")
    const [error, setError] = useState(false)
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState<boolean>(false)

    
    const [banner2Open, setBanner2Open] = useState<boolean>(false)
        

    if (session.status === "loading") {
        return <p>Carregando...</p>;
    }

    if (session.status === "authenticated") {
        // router.push("/dashboard");
        redirectToTheBestHome();
    }
    
    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setError(false)
        setMessage('')
        setLoading(true)
        
        // Como aqui é front, vamos ter que usar a api pública
        const publicApiUrl = process.env.NEXT_PUBLIC_BACKEND_URL

        await fetch(publicApiUrl + '/api/forgot-password', {
            method: 'POST',
            body: JSON.stringify({
                email,
            }),
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json" 
            },
        })
        .then(res => res.json())
        .then(result => {
            console.log('Sucesso')
            console.log(result)

            if(result.message === 'success') {
                setLoading(false)
                setMessage(result.data.status)
                setBanner2Open(true)

            } else {
                setLoading(false)
                setError(true)
                setMessage(result.message)
                setBanner2Open(true)
            }
            
        })
        .catch(error => {
            setLoading(false)
            console.log('Error')
            console.log(error)
        })
          
    }

    return(
        
        <form onSubmit={submitForm}>
            
            <div className="space-y-4">
                <div>
                <label className="block text-sm font-medium mb-1" htmlFor="email">Email</label>
                    
                    <Input
                        id="email"
                        type="email"
                        value={email}
                        className="form-input w-full"
                        onChange={(e: { target: { value: SetStateAction<string> } }) => setEmail(e.target.value)}
                        required
                        autoFocus
                    />
                </div>
            </div>
            <div className="flex justify-end mt-6">
                <Button
                    loading={loading} 
                    loadingText='Enviando...'
                    type="submit" 
                    aria-label="Send link"
                >
                    Enviar Link
                </Button>                
            </div>

            {/* Footer */}
            <div className="pt-5 mt-6 border-t border-slate-200 dark:border-slate-700">
                
                {/* Warning */}
                <Banner02 type={error ? 'error' : 'success'} open={banner2Open} setOpen={setBanner2Open}>
                    {message}
                </Banner02>
                
            </div>

        </form>
        
    )
}
